import { render, staticRenderFns } from "./ContestAllyOrderComponent.vue?vue&type=template&id=15c62dc2"
import script from "./ContestAllyOrderComponent.vue?vue&type=script&lang=js"
export * from "./ContestAllyOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports